import React from 'react'
import { Route, Routes } from 'react-router-dom'
import { Home } from './pages/Home'
import OldLouiePrivacyPolicy from './pages/OldLouiePrivacyPolicy'
import OldLouieTermsAndContition from './pages/OldLouieTermsAndContition'
import { JoinLouieTeam } from './pages/JoinLouieTeam'
import PrivacyPolicy from './pages/PrivacyPolicy'

const AllRoutes = () => {
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/privacy" element={<OldLouiePrivacyPolicy />} />
      <Route path="/terms" element={<OldLouieTermsAndContition />} />
      <Route path="/join-louie-team" element={<JoinLouieTeam />} />
      <Route path="/privacy-policy" element={<PrivacyPolicy />} />
    </Routes>
  )
}

export default AllRoutes
